import React, { useEffect } from 'react';
import { XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);
  return <AnimatePresence data-id="element-180">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-181">
          <div className="absolute inset-0 bg-black/50" onClick={onClose} data-id="element-182" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.25
      }} className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" data-id="element-183">
            <div className="flex items-center justify-between p-6 border-b border-brand-creamDark" data-id="element-184">
              <h3 className="text-2xl font-serif font-bold text-brand-brown" data-id="element-185">
                {title}
              </h3>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-brand-creamDark transition-colors" aria-label="Cerrar" data-id="element-186">
                <XIcon className="w-6 h-6 text-brand-brown" data-id="element-187" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-brand-brown/80 text-base leading-relaxed" data-id="element-188">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}